import { axiosAPI } from '../../middleware/api';

export const POST_LIST_INFO = "POST_LIST_INFO";

export function FetchListParam(_id, id) {

    const request = axiosAPI.get(`/list/${_id}/${id}`);

    return {
        type: POST_LIST_INFO,
        payload: request
    }
}
